import { render, staticRenderFns } from "./mobileLayout.vue?vue&type=template&id=e1590a30&scoped=true&"
import script from "./mobileLayout.vue?vue&type=script&lang=js&"
export * from "./mobileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1590a30",
  null
  
)

export default component.exports